/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

export type Product = {
 NameFirst: string;
 NameLast: string;
 ExtCode: string;
 IntCode: string;
 Telephone: string;
 Modified: string;
 IsEnabled: boolean;
 Id: number;
 FullName: string;
};

interface ProductsState extends CommonState {}

const initialState: ProductsState = {
 ...initialCommonState,
};

const productsSlice = createSlice({
 name: 'products',
 initialState,
 reducers: commonReducers,
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemsStart,
 deleteItemsSuccess,
 deleteItemsFailure,
 deleteItemsFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,
} = productsSlice.actions;
export default productsSlice;
